type TipoAcesso = 'parceiro' | 'admin' | 'admin_estabelecimento';

export enum EnumTipoAcesso {
  PARCEIRO = 'parceiro',
  ADMIN = 'admin',
  ADMIN_ESTABELECIMENTO = 'admin_estabelecimento',
}

export default TipoAcesso;
